import { DaymapQuery as e } from "../../daymapQuery.js";
var n;
((s) => {
  class u extends e {
    constructor(t) {
      super(
        ["studentyear", t.studentId],
        t,
        `/lms/api/assessment/qceSubjects/studentyear/?studentID=${t.studentId}`,
        null,
        { stale: 1e3 }
        // 1 minute
      );
    }
  }
  s.StudentYear = u;
  class d extends e {
    constructor(t) {
      super(
        ["tasksforstudent", t.studentId, t.year],
        t,
        `/lms/api/assessment/qceSubjects/tasksforstudent?unitFlag=15&iaFlag=255&studentID=${t.studentId}&year=${t.year}`,
        null,
        { stale: 1e3 }
        // 1 minute
      );
    }
  }
  s.TasksForStudent = d;
  class l extends e {
    constructor(t) {
      super(
        ["hasqcetask", t.studentId],
        t,
        `/lms/api/assessment/qceSubjects/hasqcetask/?studentID=${t.studentId}`,
        null,
        { stale: 1e3 }
        // 1 minute
      );
    }
  }
  s.HasQCETask = l;
})(n || (n = {}));
export {
  n as qcesubjects
};
//# sourceMappingURL=index.js.map
